<template>
  <header class="app-header">
    <div class="page-container">
      <div class="app-header__body">
        <div class="app-header__col app-header__left">
          <router-link :to="{ name: 'home' }" class="app-header__logo"
            ><app-logo></app-logo
          ></router-link>
        </div>
        <div class="app-header__col app-header__right">
          <div class="app-header-loggedin" v-if="store.isLoggedIn">
            <account-navigation></account-navigation>
            <account-dropdown></account-dropdown>
          </div>
          <sign-in-link v-else-if="route.name !== 'account-login'" />
        </div>
        <menu-burger v-if="true"></menu-burger>
        <mobile-menu v-if="true"> </mobile-menu>
      </div>
    </div>
  </header>
</template>

<script setup>
import AppLogo from '@modules/app-logo/app-logo.vue'
import AccountNavigation from '@modules/app-header/account/navigation.vue'
import AccountDropdown from '@modules/app-header/account/dropdown.vue'
import MenuBurger from './menu-burger.vue'
import MobileMenu from './mobile-menu.vue'

import SignInLink from './sign-in-link.vue'

import { useAuthStore } from '@/stores/auth'
import { useRoute } from 'vue-router'

const store = useAuthStore()
const route = useRoute()
</script>
